<template>
  <div>
    <!-- 修改昵称 -->
    <SetUsernameDialog
      v-if="showUsernameDialog"
      :userInfoName="userInfo.forum_user.forum_name"
      @closeDialog="showUsernameDialog = false"
    />
    <!-- 修改个性签名 -->
    <SetMottoDialog
      v-if="showMottoDialog"
      :userInfoMotto="userInfo.forum_user.motto"
      @closeDialog="showMottoDialog = false"
    />
    <TopHeader headerTitle="个人主页" :isShowMenuIcon="false" backgroundColor="#efefef" />
    <!-- 单元格数组 -->
    <van-cell
      v-for="(item, index) of cellConfig"
      :key="index"
      :class="$style.cells"
      :title="item.title"
      :is-link="item.isLink"
      :value="item.value"
      :to="item.to"
      @click="clickCell(item.title)"
      :value-class="$style.cellitem"
    >
      <template v-if="item.title == '我的头像'">
        <img :class="$style.avater" :src="userInfo.forum_user.forum_image" alt="" />
      </template>
    </van-cell>
  </div>
</template>

<script>
import TopHeader from '_c/TopHeader';
import SetUsernameDialog from './components/SetUsernameDialog';
import SetMottoDialog from './components/SetMottoDialog';
import { Cell, Toast, Icon } from 'vant';
import { setAvatar } from '@/api/account';
import { reportData } from '@/api/report';
import UploadMixin from "@/mixins/uploadImage";
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  components: {
    TopHeader,
    SetUsernameDialog,
    SetMottoDialog,
    VanCell: Cell,
    VanIcon: Icon
  },
  mixins: [UploadMixin],
  data() {
    return {
      showUsernameDialog: false,
      showMottoDialog: false
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: state => state.userInfo
    }),
    // 单元格配置
    cellConfig() {
      return [{
        title: '我的头像',
        isLink: true,
      }, {
        title: '昵称',
        isLink: true,
        value: this.userInfo.forum_user.forum_name
      }, {
        title: '个性签名',
        isLink: true,
        value: this.userInfo.forum_user.motto
      }]
    }
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING'
    }),
    ...mapActions('account', {
      getUserInfo: 'getUserInfo'
    }),
    async setAvatar(src) {
      this.CHANGE_SHOW_LOADING(true)
      let r = {}
      try {
        r = await setAvatar({
          image: src
        })
        this.getUserInfo()
        if (r.code == 0) {
          Toast.fail(r.message)
        } else {
          Toast.success('头像更换成功')
        }
      } catch (error) {
        Toast.fail(error.message)
      } finally {
        this.CHANGE_SHOW_LOADING(false)
      }
    },
    // 修改用户头像
    changeAvatar() {
      this.uploadImage(1, false)
    },
    clickCell(title) {
      switch (title) {
        case '我的头像':
          reportData({
            type: 4,
            data_type: 7
          })
          this.changeAvatar();
          break;
        case '昵称':
          reportData({
            type: 4,
            data_type: 8
          })
          this.showUsernameDialog = true
          break;
        case '个性签名':
          reportData({
            type: 4,
            data_type: 9
          })
          this.showMottoDialog = true
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.cells {
  .avater {
    width: 25px;
    height: 25px;
    display: inline-block;
    border: 2px solid white;
    border-radius: 50%;
  }
}
.cellitem {
  @include ellipsis(1);
  line-height: 0.32rem;
}
</style>